<template>
    <div class="rivacypolicy">
            <el-row type="flex"
                    class="row-bg"
                    justify="center">
                <el-col :span="20">
                <div class="agreement">
                    <h1 class="page-title">《壹米滴答隐私政策》</h1>
                    <div class="high_40">更新时间：2025-10-21</div>
                    <div class="high_40">生效时间：2025-10-21</div>
                    <div class="high_40">开发者名称：壹米滴答有限公司</div>
                    <div>您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴于此，我们制定本《隐私权政策》（下称"本政策/本隐私权政策"），并提醒您：希望您在使用壹米滴答及相关服务前仔细阅读并理解本隐私权政策，以便做出适当的选择，其中，<span class="bold-underline">有关您个人信息权益的条款重要内容我们已用加粗形式提示，请特别关注。</span></div>
                    <div><span class="bold-underline">本隐私权政策将帮助您了解：</span></div>
                    <div>我们会遵循隐私政策收集、使用您的信息，但不会仅因您同意本隐私权政策而采用强制捆绑的方式一揽子收集个人信息。</div>
                    <div>当您使用或开启相关功能或使用服务时，为实现功能、服务所必需，我们会收集、使用相关信息。除非是为实现基本业务功能或根据法律法规要求所必需的必要信息，您均可以拒绝提供且不影响其他功能或服务。我们将在隐私权政策中说明哪些是必要信息。</div>
                    <div>如果您未登录帐号，我们会通过设备对应的标识符信息来保障信息推送的基本功能。如果您登录了帐号，我们会根据帐号信息实现信息推送。</div>
                    <div><span class="bold-underline">地理位置、相机相册、摄像头</span>，均不会默认开启，只有经过您的明示授权才会在为实现特定功能或服务时使用，您也可以撤回授权。<span class="bold-underline">特别需要指出的是，即使经过您的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时而收集您的信息。</span>关于我们具体调用的权限及说明，可查阅<span
                        @click="toCollectPermission" class="text_link">《壹米滴答权限调用清单》</span>。</div>
                    <div class="bold-underline">特别注意事项：</div>
                    <div><span class="bold-underline">本政策适用于壹米滴答提供的所有产品和服务。</span>如我们关联公司的产品或服务中使用了壹米滴答提供的产品或服务，但未设独立隐私权政策的，则本政策同样适用于该部分产品或服务。</div>
                    <div><span class="bold-underline">需要特别说明的是，本政策不适用于其他第三方向您提供的服务，也不适用于壹米滴答中已另行独立设置法律声明及隐私权政策的产品或服务。</span>例如壹米滴答上的商家依托壹米滴答向您提供服务时，您向商家提供的个人信息不适用本政策。关于我们与第三方的合作规则及您的相关权利，可参考<span @click="toThirdpart" class="text_link">《壹米滴答第三方服务协议》。</span></div>
                    <div><span class="bold-underline">在使用壹米滴答各项产品或服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后使用相关产品或服务。一旦您开始使用壹米滴答各项产品或服务，即表示您已充分理解并同意本政策。</span></div>
                    <div><span class="bold-underline">有任何疑问，可联系壹米滴答有限公司，地址位于上海青浦区徐泾镇徐民路168弄中建企业天地·东区1号楼6层，可通过95058官方客服电话联系我司。</span></div>
                    <div>本隐私权政策将帮助您了解以下内容：</div>
                    <div>一、我们如何收集和使用个人信息</div>
                    <div>二、我们如何使用Cookie和同类技术</div>
                    <div>三、我们如何共享、转让、公开披露您的信息</div>
                    <div>四、您如何访问和控制自己的个人信息</div>
                    <div>五、我们如何保护您的信息</div>
                    <div>六、我们如何处理未成年人的信息</div>
                    <div>七、您的信息如何在全球范围转移</div>
                    <div>八、本隐私权政策如何更新</div>
                    <div>九、名词解释</div>
                    <div>十、联系我们</div>
                    <div>十一、账号注销相关约定</div>
                    <div class="title_level_1">一、我们如何收集和使用个人信息</div>
                    <div><span class="bold-underline">1、注册、登录</span></div>
                    <div>（1） 当您注册、登录壹米滴答及相关服务时，您可以通过经过实名认证的手机号创建账号，收集此信息是为了帮助您完成注册和根据手机号拉取对应的业务信息以便您更好的完成工作。</div>
                    <div>（2）您也可以使用第三方账号登录并使用，您将授权我们获取您在第三方平台注册的公开信息<span class="bold-underline">（头像、昵称、地区以及性别信息）</span>，用于与壹米滴答账号绑定，使您可以直接登录并使用本产品和相关服务。</div>
                    <div>（3） 基于我们与通信运营商及其合作伙伴的合作，我们可能会向您提供"一键登录"功能，经过您的明示同意，运营商会将您的手机号码发送给我们，便于我们为您提供快捷的登录服务。您也可以自主选择手动填写手机号码的方式完成注册或登录。</div>
                    <div>（4） 您注册的账号可以使用或登录壹米滴答关联方的产品，并获得相关服务或使用相关功能。</div>
                    <div>如果您已拥有壹米滴答平台账户，我们可能会在壹米滴答平台服务中显示您的上述个人信息，以及您在壹米滴答平台上或与壹米滴答平台账户相关联的产品和服务中执行的操作，例如通过壹米滴答平台账户集中展示您的个人资料或交易订单。若您不提供这类信息，您将无法登录和享受购买服务，此时您可使用浏览和搜索功能，我们将不会收集您的上述个人信息。</div>
                    <div><span class="bold-underline">2、商品/服务信息展示及浏览</span></div>
                    <div>（1） 为向您提供商品/服务信息展示及浏览服务，帮助优化服务和排查使用过程中遇到的问题并向您推荐您可能更感兴趣的信息，我们可能会收集您使用我们产品与/或服务的设备信息、浏览记录和服务日志信息。包括：</div>
                    <div>设备信息：我们会根据您在访问及/或使用中的具体操作，接收并记录您所使用的设备相关信息（包括<span class="bold-underline">设备型号、操作系统版本、设备设置、MAC地址及IMSI、IMEI、AndroidID、IDFA、OAID设备标识符、设备环境、剪切板、移动应用列表、电信运营商软硬件特征信息、SD卡数据、安装列表、设备序列号、传感器）、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站传感器信息</span>）。我们不会直接存储和使用原始数据。</div>
                    <div>服务日志信息：当您访问或使用壹米滴答提供的产品或服务时，我们会自动收集和记录您的详细使用情况，作为服务日志保存，包括<span class="bold-underline">浏览记录、点击查看记录、收藏、关注分享信息，以及IP地址、浏览器类型、电信运营商、使用语言、访问日期和时间</span>。</div>
                    <div>（2）请您理解，单独的设备信息、网络信息、日志信息等是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外， 我们会将收集、使用的上述信息进行去标识化处理，数据分析仅对应特定的、无法直接关联您身份的编码，不会与您的真实身份相关联。</div>
                    <div><span class="bold-underline">3、预约、客服和售后服务</span></div>
                    <div>（1）使用产品及/或服务需求：您通过壹米滴答下单或预约相关服务时，您可能需要提供<span class="bold-underline">预约人信息（姓名、电话号码、地址、服务偏好等</span>。您预约相关产品及/或服务并提供上述信息的行为，即表示您同意我们通过该信息与您进行联系，以便进一步核对您的需求。</div>
                    <div>（2）客服和售后服务：当您与我们的客服取得联系时，我们的系统可能会记录您与客服之间的<span class="bold-underline">沟通信息（文字、语音）</span>，以及使用您的账号信息以便核验身份；当您需要我们提供与您项目、订单相关的客户服务时，我们可能会查询您的相关订单信息以便给予您适当的帮助和处理；当您需要客服协助您修改有关信息（包括配送地址、联系方式）时，您可能还需要提供上述信息外的其他信息以便完成修改。为了保证服务体验、处理服务纠纷，您与我们的客服、商家的<span class="bold-underline">沟通信息（文字、语音）</span>可能会被收集。经授权，当发生服务纠纷时，我们可调取并使用<span class="bold-underline">沟通信息（文字、语音）</span>作为解决纠纷的参考依据。</div>
                    <div><span class="bold-underline">4、安全保障</span></div>
                    <div><span class="bold-underline">（1）运营与安全保障</span></div>
                    <div>我们致力于为您提供安全、可信的产品与使用环境，提供优质、高效、可靠的服务与信息是我们的核心目标。</div>
                    <div><span class="bold-underline">（2）设备信息、网络信息与日志信息</span></div>
                    <div>a. 为了保障软件与服务的安全，运营的质量和效率，我们会收集您的设备信息（包括<span class="bold-underline">唯一设备识别码、设备型号、设备名称、设备标识、浏览器类型和设置、语言设置、操作系统和应用程序版本、产品版本号）、网络信息（登录IP地址、接入网络的方式、网络质量数据、移动网络信息）、日志信息（操作、使用、服务日志）</span>。我们不会直接存储和使用原始数据。</div>
                    <div>b. 为了预防恶意程序及安全、确保运营质量及效率，我们会收集安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。</div>
                    <div><span class="bold-underline">c. 在此您郑重确认并同意：我们可以使用您的账户信息、设备信息、网络信息、日志信息以及我们关联公司、合作方在获得您授权或依法可以共享的信息，用于判断账户安全、进行身份验证、检测和打击黑产、检测及防范安全事件。</span></div>
                    <div><span class="bold-underline">6、依法豁免征得同意收集和使用的个人信息</span></div>
                    <div>请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：</div>
                    <div>(1)与您履行法律法规规定的义务相关的；</div>
                    <div>(2)与国家安全、国防安全直接相关的；</div>
                    <div>(3)与公共安全、公共卫生、重大公共利益直接相关的；</div>
                    <div>(4)与犯罪侦查、起诉、审判和判决执行等直接相关的；</div>
                    <div>(5)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</div>
                    <div>(6)所收集的您的个人信息是您自行向社会公众公开的；</div>
                    <div>(7)从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</div>
                    <div>(8)根据您的要求签订或履行合同所必需的；</div>
                    <div>(9)用于维护软件及相关服务的安全稳定运行所必需的，例如发现、处置软件及相关服务的故障；</div>
                    <div>(10)为合法的新闻报道所必需的；</div>
                    <div>(11)学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</div>
                    <div>(12)法律法规规定的其他情形。</div>
                    <div>特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本隐私权政策处理与保护。</div>
                    <div><span class="bold-underline">7、 收集、使用个人信息目的变更</span></div>
                    <div>请您了解，随着我们业务的发展，可能会对壹米滴答的功能和提供的服务有所调整变化。如果您选择使用本隐私政策中尚未列明的其他产品与/或服务时，我们会在收集您的个人信息前通过协议、页面提示等方式向您详细说明信息收集的目的、方式、范围并征求您的同意。若您不同意提供前述信息，您可能无法使用该项产品与/或服务，但不影响您使用现有产品与/或服务。</div>
                    <div><span class="bold-underline">8、自启动和关联启动说明</span></div>
                    <div>为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。</div>
                    <div><span class="bold-underline">9、实名认证</span></div>
                    <div>在您使用需实名认证的功能或服务时，为符合法律法规规定及相关监管要求，需要您提供<span class="bold-underline">真实身份信息（真实姓名、身份证件号码，根据实际情况可能有所不同）</span>以完成实名认证。在实名认证的过程中，可能需要由提供认证服务的第三方认证机构（腾讯云计算（北京）有限责任公司、支付宝（杭州）信息技术有限公司、腾讯科技（深圳）有限公司）核验您的真实身份信息。具体的个人信息处理规则请参见该第三方机构自行设立的隐私政策、服务协议或类似文本。这些信息仅供实名认证及法律法规所规定的用途，未经您明示授权，不会用作其他目的。</div>
                    <div>以上信息属于敏感个人信息，您可以拒绝提供，且不会影响壹米滴答其他功能/服务的正常使用，但您将可能无法使用必须实名认证才可使用的功能或相关服务。</div>
                    <div class="title_level_1">二、我们如何使用Cookie和同类技术</div>
                    <div>1、Cookie</div>
                    <div>为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储Cookie、Flash Cookie，或浏览器（或关联应用程序）提供的其他通常包含标识符、站点名称以及一些号码和字符的本地存储（统称"Cookie"）。借助于Cookie，网站能够存储您的偏好或购物车内的商品等数据。</div>
                    <div><span class="bold-underline">如果您的浏览器或浏览器附加服务允许，您可修改对Cookie的接受程度或拒绝我们的Cookie。</span></div>
                    <div>2、Cookie 同类技术</div>
                    <div>除 Cookie外，我们还会在网站上使用网站信标、像素标签、ETag等其他同类技术。</div>
                    <div>例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好，以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。</div>
                    <div>ETag（实体标签）是在互联网浏览器与互联网服务器之间背后传送的HTTP协议标头，可代替Cookie。ETag可以帮助我们避免不必要的服务器负载，提高服务效率，节省资源、能源，同时，我们可能通过ETag来记录您的身份，以便我们可以更深入地了解和改善我们的产品或服务。<span class="bold-underline">大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。</span>但请注意，如果停用ETag，您可能无法享受相对更佳的产品或服务体验。</div>
                    <div class="title_level_1">三、我们如何共享、转让、公开披露您的信息</div>
                    <div><span class="bold-underline">1、共享</span></div>
                    <div><span class="bold-underline">（1）共享原则</span></div>
                    <div><span class="bold-underline">a. 授权同意原则：</span>向我们的第三方共享您的个人信息，需经过您的授权同意，所共享的个人信息是去标识化处理后的信息或共享第三方无法识别此类信息的自然人主体的信息，除非我们向关联方共享必要的个人信息，且受本隐私权政策中所声明目的的约束。如果关联方、第三方使用信息的目的超越原授权同意范围，他们需要重新征得您的同意。</div>
                    <div><span class="bold-underline">b. 合法正当与最小必要原则：</span>向关联方、第三方共享的数据必须具有合法正当目的，且共享的数据以达成目的必要为限。</div>
                    <div><span class="bold-underline">c. 安全审慎原则：</span>我们将审慎评估关联方、第三方数据使用共享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。</div>
                    <div><span class="bold-underline">（2）共享信息情形</span></div>
                    <div>我们不会与壹米滴答服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：</div>
                    <div>a.在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</div>
                    <div>b.在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</div>
                    <div>c.在您主动选择情况下共享：您通过壹米滴答平台生成的订单或服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息（可能包括您的联络信息、订单信息、地址信息等）共享给相关商品或服务的提供者，以实现您的交易及售后服务需求。</div>
                    <div>d.与关联公司间共享：<span class="bold-underline">您的个人信息不会与我们的关联公司和/或其指定的服务提供商共享。</span>若有确需我们共享您的个人信息给关联公司的，将征求您的授权同意，且受本隐私政策中所声明目的的约束。</div>
                    <div><span class="bold-underline">2、转让</span></div>
                    <div>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</div>
                    <div>（1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</div>
                    <div>（2）在壹米滴答服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</div>
                    <div><span class="bold-underline">3、公开披露</span></div>
                    <div>我们仅会在以下情况下，公开披露您的个人信息：</div>
                    <div>（1）获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</div>
                    <div>（2）<span class="bold-underline">如果我们确定您出现违反法律法规或严重违反壹米滴答平台相关协议及规则的情况，或为保护壹米滴答平台用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息，包括</span>相关违规行为以及壹米滴答平台已对您采取的措施。</div>
                    <div>4、共享、转让、公开披露个人信息时事先征得授权同意的例外</div>
                    <div>在下列情形中，共享、转让、公开披露您的个人信息无需征得您的授权同意：</div>
                    <div>（1）与国家安全、国防安全有关的；</div>
                    <div>（2）与公共安全、公共卫生、重大公共利益有关的；</div>
                    <div>（3）与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；</div>
                    <div>（4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</div>
                    <div>（5）您自行向社会公众公开的个人信息；</div>
                    <div>（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</div>
                    <div><span class="bold-underline">请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。</span></div>
                    <div class="title_level_1">四、您如何访问和控制自己的个人信息</div>
                    <div>壹米滴答鼓励您更新和修改您的信息以使其更准确有效。我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。</div>
                    <div><span class="bold-underline">1、访问、更新和更正您的个人信息</span></div>
                    <div>除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：</div>
                    <div>（1）您的账户信息：移动端具体路径为：首页--"个人中心"进入个人主页再点击头像进入"编辑个人资料"页面查阅或更新个人信息；</div>
                    <div>（2）您可通过<span @click="toCollectIndividual" class="text_link">《壹米滴答已收集个人信息清单》</span>，清晰查看我们当前已收集的您的个人信息具体类型及来源，了解信息收集的全貌。</div>
                    <div><span class="bold-underline">2、如您在使用我们的产品与/或服务过程中产生的其他个人信息需要访问或更正，或您无法通过上述链接（含<span @click="toCollectIndividual" class="text_link">《壹米滴答已收集个人信息清单》</span>、<span @click="toCollectPermission" class="text_link">《壹米滴答权限调用清单》</span>、<span @click="toThirdpart" class="text_link">《壹米滴答第三方服务协议》</span>、<span @click="toCorporation" class="text_link">《壹米滴答合作方清单》</span>）管理这些个人信息，您可以随时将您的问题通过我们的官方电话95058予以反馈，我们核查后会及时回复您的访问请求。</span></div>
                    <div><span class="bold-underline">3、改变您授权同意的范围或撤回授权</span></div>
                    <div>您可以通过在我们的网站、App中删除信息、更改隐私设置以及在浏览器或操作系统中关闭设备功能等方式改变同意范围或撤回您的授权。请您理解，当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，但不会影响此前基于您的授权而开展的个人信息处理。</div>
                    <div><span class="bold-underline">4、投诉举报</span></div>
                    <div>您可按照我们公示的制度进行投诉或举报。如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索（例如：认为我们收集您的个人信息违反法律规定或者双方约定），您可以通过95058与我们联系。我们核查后会及时反馈您的投诉与举报。一般情况下，我们将在15个工作日内核查和处理。</div>
                    <div><span class="bold-underline">5、 访问隐私政策</span></div>
                    <div>（1）您可以在注册页面，或者在登录个人账号在个人中心查看本隐私权政策的全部内容或通过网页端查看本隐私权政策全部内容。</div>
                    <div>（2）请您了解，本隐私权政策中所述的"壹米滴答"及相关服务可能会根据您所使用的手机型号、系统版本、软件应用程序版本、移动客户端等因素而有所不同。最终的产品和服务以您所使用的"壹米滴答"软件及相关服务为准。</div>
                    <div><span class="bold-underline">6、 停止运营向您告知</span></div>
                    <div>如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。</div>
                    <div class="title_level_1">五、我们如何保护您的信息</div>
                    <div>1、我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。目前,优给物流已经通过了国家信息安全等级保护（三级）的测评和备案。 我们会使用不低于行业同行的加密技术、匿名化处理及相关合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。</div>
                    <div>2、我们有行业先进的以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。</div>
                    <div>3、我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息（除非法律有强制的存留要求）。</div>
                    <div>4、<span class="bold-underline">尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。</span>互联网并非绝对安全的环境，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</div>
                    <div>您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</div>
                    <div>5、我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过壹米滴答公告方式获得。</div>
                    <div>6、在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</div>
                    <div>同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</div>
                    <div class="title_level_1">六、我们如何处理未成年人的信息</div>
                    <div><span class="bold-underline">1、在电子商务活动中我们推定您具有相应的民事行为能力。如您为未成年人，我们要求您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。</span></div>
                    <div>2、对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</div>
                    <div class="title_level_1">七、您的信息如何在全球范围转移</div>
                    <div><span class="bold-underline">1、存储地点</span></div>
                    <div><span class="bold-underline">我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：</span></div>
                    <div><span class="bold-underline">（1）适用的法律有明确规定；</span></div>
                    <div><span class="bold-underline">（2）获得您的明确授权；</span></div>
                    <div><span class="bold-underline">（3）您通过互联网进行跨境交易等个人主动行为。</span></div>
                    <div><span class="bold-underline">针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。</span></div>
                    <div><span class="bold-underline">2、存储期限</span></div>
                    <div>我们仅在为提供壹米滴答产品及服务之目的所必需的期间内保留您的个人信息：您账户信息、订单信息、发布的信息、评论、点赞及相关信息，在您未撤回、删除或未注销账号期间，我们会保留相关信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。</div>
                    <div class="title_level_1">八、本隐私权政策如何更新</div>
                    <div>为了给您提供更好的服务，壹米滴答及相关服务将不定时更新与变化，我们会适时对本隐私政策进行更新，这些更新构成本隐私权政策的一部分并具有等同于本隐私权政策的效力，未经您明确同意，我们不会削减您依据当前生效的本隐私权政策所应享受的权利。</div>
                    <div><span class="bold-underline">本隐私权政策更新后，我们会在壹米滴答发出更新版本，并在更新后的条款生效前通过官方网站（www.yimidida.com）公告或其他适当的方式提醒您更新的内容,</span>对于重大变更，我们还会提供更为显著的通知，以便您及时了解本隐私权政策的最新版本。</div>
                    <div>本政策所指的重大变更：</div>
                    <div>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</div>
                    <div>2、我们在控制权等方面发生重大变化。如并购重组等引起的信息控制者变更等；</div>
                    <div>3、个人信息共享、转让或公开披露的主要对象发生变化；</div>
                    <div>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</div>
                    <div>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</div>
                    <div>6、个人信息安全影响评估报告表明存在高风险。</div>
                    <div class="title_level_1">九、 名词解释</div>
                    <div>除非另有约定，本隐私权政策中使用到的名词，通常仅具有以下定义：</div>
                    <div>1、 个人信息：<span class="bold-underline">以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私权政策中可能涉及的个人信息包括：自然人的基本资料（个人电话号码、电子邮件地址）、网络身份标识信息（个人信息主体账号、IP 地址、个人数字证书）、日志信息（操作日志、服务日志）、个人常用设备信息（指包括硬件序列号、软件列表、唯一设备识别码（包括 IMEI/Android ID/IDFA/OpenUDID/GUID/SIM 卡 IMSI 信息）在内的描述个人常用设备基本情况的信息）、个人位置信息（包括大概地理位置、精确定位信息）。我们实际具体收集的个人信息种类以本文描述为准。</span></div>
                    <div>2、个人敏感信息:<span class="bold-underline">是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息。本隐私政策可能涉及的个人敏感信息包括：个人财产信息、网络身份标识信息、通讯录信息、精准定位信息、收货地址。我们实际具体收集的个人敏感信息种类以本文描述为准。</span></div>
                    <div>3、设备：是指可用于访问我们的产品和/或服务的装置，包括台式计算机、笔记本电脑、平板电脑或智能手机。</div>
                    <div>4、 唯一设备标识符（专属 ID 或 UUID）：是指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备（包括手机的 IMEI 号）。唯一设备标识符有多种用途，其中可在不能使用 Cookie（包括在移动应用程序中）时用以提供广告。</div>
                    <div>5、 IP 地址：每台上网的设备都会指定一个编号，称为互联网协议 ( IP ) 地址。这些编号通常都是根据地理区域指定的。IP地址通常可用于识别设备连接至互联网时所在的位置。</div>
                    <div>6、 Cookie：Cookie是包含字符串的小文件，在您登入和使用网站或其他网络内容时发送、存放在您的计算机、移动设备或其他装置内（通常经过加密）。Cookie同类技术是可用于与Cookie类似用途的其他技术。</div>
                    <div>7、 账号：当您注册账号并向我们提供一些个人信息，您就可以更好的使用我们的服务。当您访问壹米滴答时，系统会利用这些账号信息对您进行身份验证，以防止未经授权的人员访问您的账号。</div>
                    <div>8、 去标识化/匿名化：是指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体，且处理后的信息不能被复原的过程。</div>
                    <div class="title_level_1">十、 联系我们</div>
                    <div>1、小程序由壹米滴答有限公司提供，地址位于上海青浦区徐泾镇徐民路168弄中建企业天地·东区1号楼6层，如果您对个人信息保护相关的稳私政策有投诉、建议、疑问，您可以通过官方电话95058联系我们，我们核查并验证您的用户身份后会及时反馈您的投诉与举报。</div>
                    <div>3、一般情况下，我们将在15个工作日内核查和处理。如果您对我们的处理不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商监管部门进行投诉或举报。</div>
                    <div class="title_level_1">十一、账号注销相关约定</div>
                    <div>尊敬的用户，在您注销壹米滴答账号前，请充分阅读、理解并同意以下条款：</div>
                    <div>1、账号注销操作不可逆，一旦完成注销，您将无法通过找回密码、重新注册等方式恢复原账号，也无法获取原账号的任何权限。</div>
                    <div>2、请您在注销前自行备份账号相关的所有信息和数据（包括但不限于地址簿、绑定关系、历史操作记录等），注销后壹米滴答将无法为您提供数据恢复服务。</div>
                    <div>3、注销成功后，您将无法再通过壹米滴答公众号、官网等任何渠道登录或使用原账号，原账号项下的用户名、头像、绑定关系等所有内容及信息（运单信息除外，详见本条第 4 款）将无法找回。</div>
                    <div>4、依据《中华人民共和国个人信息保护法》等相关法律法规，您的运单信息将按照壹米滴答《隐私政策》约定的 "必要留存期限" 保存，保存期间您可通过运单号在官网或公众号查询物流信息；留存期满后，壹米滴答将对该等信息进行删除或匿名化处理，不再关联您的个人身份。</div>
                    <div>5、注销前，您需确保账号无未结清费用、未完成的服务（如未签收快件、未处理的理赔等）；若存在上述情形，壹米滴答有权暂缓或拒绝注销申请。</div>
                    <div>6、账号注销后，原账号已绑定的银行卡、业务员、地址簿、授权账户等关联关系将自动解除，如需再次使用壹米滴答服务，需重新注册账号并绑定相关信息。</div>
                    <div>7、账号注销不代表注销前的账号行为及相关法律责任得到豁免或减轻，您仍需对注销前的账号操作承担相应责任。</div>
                    <div>如您对账号注销事宜有任何疑问，可拨打客服热线 95058 咨询反馈。</div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { queryPrivacyPolicy } from "@/api/homePage";
export default {
    components: {},
    data() {
        return {
            conenttext: ""
        };
    },
    computed: {},
    mounted() {},
    watch: {},
    created() {
        //this.query();
    },
    methods: {
       /* query() {
            queryPrivacyPolicy()
                .then(res => {
                    if (res.status === 2000) {
                        this.conenttext = res.data.osArticleContent.content;
                    }
                })
                .catch(err => {});
        }*/
        // 跳转到权限调用清单
        toCollectPermission() {
            this.$router.push({
                path: "/collectPermission",
                query: {
                    id: "50EAA720-D4C9-476F-0ACC-8FDC0CBB7224"
                }
            });
        },
        // 跳转到第三方服务协议
        toThirdpart() {
            this.$router.push({
                path: "/thirdpart",
                query: {
                    id: "50EAA720-D4C9-476F-0ACC-8FDC0CBB7224"
                }
            });
        },
        // 跳转到已收集个人信息清单
        toCollectIndividual() {
            this.$router.push({
                path: "/collectindividual",
                query: {
                    id: "50EAA720-D4C9-476F-0ACC-8FDC0CBB7224"
                }
            });
        },
        // 跳转到合作方清单
        toCorporation() {
            this.$router.push({
                path: "/corporation",
                query: {
                    id: "50EAA720-D4C9-476F-0ACC-8FDC0CBB7224"
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.rivacypolicy {
    padding-bottom: 50px;
    background-color: #fff;
    .way {
        height: 50px;
        margin-top: -3px;
        background-color: #221814;
        ::v-deep .el-breadcrumb {
            line-height: 50px;
            .el-breadcrumb__item {
                line-height: 46px;
            }
            .el-breadcrumb__inner {
                font-weight: bold;
                color: #ffffff;
            }
        }
    }
    .agreement {
        padding: 20px;
        height: 100%;
        font-size: 14px;
        line-height: 1.8;
        .page-title {
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin: 0 0 30px 0;
            padding: 20px 0;
            border-bottom: 2px solid #e0e0e0;
            width: 100%;
        }
        div {
            text-indent: 1em;
            margin-bottom: 10px;
            color: #333;
        }
        .high_40 {
            height: 40px;
            text-indent: 0;
        }
        .bold-underline {
            font-weight: bold;
            text-decoration: underline;
        }
        .title_level_1 {
            text-indent: 0 !important;
            font-size: 18px;
            line-height: 40px;
            font-weight: bold;
            margin-top: 20px;
            margin-bottom: 10px;
        }
        .text_link {
            color: #FFAF00;
            font-weight: bold;
            cursor: pointer;
            text-decoration: underline;
            &:hover {
                color: #ff9500;
            }
        }
    }
}
</style>
